/** Link at api endpoint for payout royalty */
const apiUrlRoyaltyPayout = "/api/statistics/royalty/payout/";
const apiGetTransactionInfo = "/api/statistics/royalty/payout/";
const apiGetPayoutBannerData = "/api/statistics/royalty/banner/";
const apiGetRoyaltyDrafts = "/api/statistics/royalty/draft/";
export { apiUrlRoyaltyPayout, apiGetTransactionInfo, apiGetPayoutBannerData, apiGetRoyaltyDrafts };